import { Http } from '../../utils/types'
import { Format, GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { FilterArea } from './response/index'
import { AreaById, GetAllAreas, GetAllAreasWithFilter, ResponseArea } from './response'
import { formatFilterArea } from './format/filterArea'

export const areaService = (client: Http) => ({
  getAllAreas: async (): Promise<GetAllAreas> => await client.get('area'),
  getAllAreasWithFilter: async (query?: string): Promise<GetAllAreasWithFilter> => {
    return await client.get(`area${query ? '?' + query : ''}`)
  },
  createArea: async (body: ObjectGeneric): Promise<ResponseArea> => await client.post('area', body),
  updateArea: async (body: ObjectGeneric, id: number): Promise<ResponseArea> => await client.put(`area/${id}`, body),
  deleteArea: async (id: number): Promise<ResponseArea> => await client.delete(`area/${id}`),
  getAreaById: async (id?: number): Promise<AreaById> => await client.get(`area/${id}`),
  getDepartments: async (): Promise<any> => await client.get('department/without-area'),
  getAllDepartments: async (): Promise<any> => await client.get('department'),
  getfilterArea: async (): Format<FilterArea> => {
    const response = await client.get<FilterArea>('area/filters')
    return formatFilterArea({ response })
  },
  downloadFile: async (data: {
    type: string
    query?: string
  }): Promise<GetBlob> =>
    await client.getBlob?.(
      `area/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
    ),
})
